const map = {
	"./01_docker.svg": 148,
	"./02_javascript.svg": 760,
	"./03_typescript.svg": 791,
	"./04_php.png": 385,
	"./05_angular.svg": 526,
	"./06_react.svg": 482,
	"./07_tailwind-css.svg": 824,
	"./08_java.svg": 891,
	"./09_csharp.svg": 793,
	"./10_python.svg": 712,
	"./11_mysql.svg": 813,
	"./12_mongodb.svg": 934,
	"./17_azure.svg": 608
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 383;